import { useContext, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { ArraySectionsType, FormEventType } from '@pages/WindowsCreateOrEdit/types'
import { WindowsCreateOrEditContext } from '@pages/WindowsCreateOrEdit/WindowsCreateOrEdit'

import { getEmptyEvent } from '../../helpers'

type useEventProps = {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
  eventIndex: number
}

export const useEvent = ({ eventIndex, tabIndex, sectionIndex, actionIndex }: useEventProps) => {
  const [isEditEvent, setIsEditEvent] = useState<boolean>(false)
  const [eventData, setEventData] = useState<FormEventType | null>(null)

  const { watch, setValue } = useFormContext<ArraySectionsType>()

  const { windowById } = useContext(WindowsCreateOrEditContext)

  const currentEventName = `sections.${sectionIndex}.tabs.${tabIndex}.actions.${actionIndex}.events.${eventIndex}`

  const watchCurrentEvent = watch(currentEventName) as FormEventType
  const watchValue = watch(`${currentEventName}.value`)
  const watchValueType = watch(`${currentEventName}.valueType`)
  const watchEvent = watch(`${currentEventName}.event`)
  const watchPostVariable = watch(`${currentEventName}.postVariable`)

  const handleResetEvent = () => {
    setValue(currentEventName, eventData ?? getEmptyEvent())
  }

  const handleSaveEvent = (values: FormEventType) => {
    setValue(currentEventName, values, { shouldDirty: true })
    setEventData(values)
  }

  const handleEditEvent = (edit: boolean) => {
    setIsEditEvent(edit)
  }

  useEffect(() => {
    if (windowById) {
      if (!watchCurrentEvent) {
        setEventData(getEmptyEvent())

        return
      }

      setEventData({
        ...watchCurrentEvent,
      })
    }
  }, [])

  return {
    handlers: {
      handleSaveEvent,
      handleEditEvent,
      handleResetEvent,
    },
    data: {
      watchValueType,
      watchEvent,
      watchPostVariable,
      watchValue,
      watchCurrentEvent,
      isEditEvent,
    },
  }
}
